"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = {
    REQUEST_USER_PROFILE: 'REQUEST_USER_PROFILE',
    CREATE_USER: 'CREATE_USER',
    FETCH_USER_PROFILE: 'FETCH_USER_PROFILE',
    PUT_USER_PROFILE: 'PUT_USER_PROFILE',
    LOG_IN_FAILED: 'LOG_IN_FAILED',
    CREATE_USER_FAILED: 'CREATE_USER_FAILED',
    DELETE_LOGIN_FAILED_ERROR: 'DELETE_LOGIN_FAILED_ERROR',
    REQUEST_NEW_PASSWORD: 'REQUEST_NEW_PASSWORD',
    FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
    FORGOT_PASSWORD_FAILED: 'FORGOT_PASSWORD_FAILED',
};
exports.actionCreators = {
    requestUserProfile: () => ({
        type: exports.actions.REQUEST_USER_PROFILE
    }),
    createUser: (email, userName, password) => ({
        type: exports.actions.CREATE_USER,
        payload: { email, userName, password }
    }),
    fetchUserProfile: (email, password) => ({
        type: exports.actions.FETCH_USER_PROFILE,
        payload: { email, password }
    }),
    putUserProfile: (userProfile) => ({
        type: exports.actions.PUT_USER_PROFILE,
        userProfile
    }),
    putLoginFailed: (error) => ({
        type: exports.actions.LOG_IN_FAILED,
        payload: {
            error
        }
    }),
    putCreateUserFailed: (error) => ({
        type: exports.actions.CREATE_USER_FAILED,
        payload: {
            error
        }
    }),
    deleteLoginFailedError: () => ({
        type: exports.actions.DELETE_LOGIN_FAILED_ERROR,
    }),
    requestNewPassword: (email) => ({
        type: exports.actions.REQUEST_NEW_PASSWORD,
        payload: { email }
    }),
    putForgotPasswordSuccess: (value) => ({
        type: exports.actions.FORGOT_PASSWORD_SUCCESS,
        payload: {
            isEmailSent: value
        }
    }),
    putForgotPasswordFailed: (error) => ({
        type: exports.actions.FORGOT_PASSWORD_FAILED,
        payload: {
            error
        }
    }),
};



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/userProfile/actions.ts